module.exports = {"en":"English","zh-CN":"Chinese","ta":"Tamil","hi":"Hindi"}


//////////////////
// WEBPACK FOOTER
// ./src/data/languages.json
// module id = 202
// module chunks = 0